import * as PIXI from 'pixi.js';
import { Scene } from "pixi-scenegraph";
import { EVENT_BUS } from '@/model/event-bus';
// import { MenuBuilder } from './ui/menu-builder';
import throttle from 'lodash.throttle';
import { NotationEngine, ONE_BAR_WIDTH_PX, PADDING, SCROLL_WINDOW_PX } from '@/components/engine';
import { WIDTH, HEIGHT } from '@/constants';
import { smoothScroll } from '@/util/tween';
import { Gui, GUI_X, GUI_Y } from '@/ui/gui';
import { activateScene } from '@/scenes';
import game from '@/model/game';
import { DebugOverlay } from '@/ui/debug-overlay';
import { createRandomParallax } from '@/components/parallax';
import { GameSceneAbstract } from '@/scenes/game-scene-abstract';
export const ENGINE_X = WIDTH * 0.235, ENGINE_Y = HEIGHT / 3 * 0.75;
const ENGINE_HEIGHT = HEIGHT * 0.55, ENGINE_WIDTH = WIDTH * (1 - 0.235);
const MS_THROTTLE_LOOKAHEAD = 2000, THROTTLE_MODE = false;

export class GameScene extends GameSceneAbstract {
    audio
    BEATS = 4
    BEAT_TYPE = 4
    chart = {}

    constructor() {
        super("game-notation"); //	this is	the scene name
        this.createBackground();
        this.notesToUpdate = [];
    }

    createBackground() {
        const background = createRandomParallax();
        this.addChild(background);
    }

    startGame() {
        super.startGame();
        // if (THROTTLE_MODE) {
        //     this.updateFn = throttle(this.updateFn, MS_THROTTLE_LOOKAHEAD);
        //     this.ticker.add(this.updateFn);
        //     this.ticker.add(this.gameUpdateFn);
        //     this.ticker.add(() => {
        //         this.engine.updateJudgementLine(
        //             this.calculateScrollPosition(this.audio.currentTimeOffsetted),
        //             this.audio.currentTimeOffsetted
        //         );
        //     });
        // } else {
        this.updateJudgementLineFn = () => {
            this.engine.updateJudgementLine(
                this.calculateScrollPosition(this.audio.currentTimeOffsetted),
                this.audio.currentTimeOffsetted
            );
        };
        this.ticker.add(() => this.updateJudgementLineFn());
        // });

    }

    update(dt) {
        if (!game.isPlaying) {
            return;
        }
        // const now = performance.now();
        const currentTime = (this.audio.currentTimeOffsetted /*- game.countInTime*/);
        this.engine.update(currentTime, game.bpm);
        // if (this.audio.currentTime < game.countInTime) {
        //     return;
        // }

        if (this.audio.currentTime >= this.audio.duration && game.isPlaying) {
            game.isPlaying = false;
            this.showResultsScreen();
        }
        // scroll
        if (currentTime > 0) {
            // this.judgementLineTime.text = Number(currentTime).toFixed(2) + 's';
            // this.updateJudgementLine(scrollPosition);
            this.ui.setProgress(game.hitPoints / game.maxHitPoints);
        }
    }

    calculateScrollPosition(currentTime, msLookahead = 0) {
        const BEATS_PER_SECOND = game.bpm / 60;
        const beatsPlayed = (currentTime + (msLookahead / 1000)) * BEATS_PER_SECOND;
        const barsPlayed = beatsPlayed / this.BEAT_TYPE;
        return barsPlayed * ONE_BAR_WIDTH_PX;
    }

    throttledUpdate(dt, msLookahead) {
        // const now = performance.now();
        const currentTime = (this.audio.currentTimeOffsetted /*- game.countInTime*/);
        const scrollPosition = this.calculateScrollPosition(currentTime, msLookahead)
        smoothScroll(this.engine, SCROLL_WINDOW_PX - scrollPosition, msLookahead);
        this.engine.update(currentTime, game.bpm);

        if (this.audio.currentTime >= this.audio.duration && game.isPlaying) {
            this.showResultsScreen();
        }

        if (currentTime > 0) {
            this.ui.setProgress(game.hitPoints / game.maxHitPoints);
        }
    }

    async loadMxl(pathToFile) {
        return super.loadMxl(pathToFile)
            .then(async ({
                measures, attributes,
                beats, beatType,
                divisionsPerQuarterNote,
                key, notes, meta, boundaries}) => {
                const engine = new NotationEngine(measures, key, divisionsPerQuarterNote,
                    ENGINE_WIDTH,
                    ENGINE_HEIGHT,
                    WIDTH - ENGINE_WIDTH,
                    ENGINE_HEIGHT)
                this.engine = engine;
                let { container, lhs, wrapper, noteSprites } = engine.getFields();

                wrapper.x = ENGINE_X;
                wrapper.y = ENGINE_Y;
                lhs.y = wrapper.y;

                this.containerToScroll = container;
                this.notesToUpdate = noteSprites;

                this.addChild(wrapper);
                this.addChild(lhs);

                this.ui = new Gui({
                    boundaries: game.settings.pianoConfig
                });
                this.ui.setProgress(1);
                this.addChild(new DebugOverlay());

                this.addChild(this.ui);

                this.updateFn = (dt) => this.throttledUpdate(dt, MS_THROTTLE_LOOKAHEAD);
                return Promise.resolve();
            }).catch(e => {
                console.error(e);
                activateScene('error', e);
            });
    }

}